export default {
  bmiIssue: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-1200',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: 'I-PE-VIT-1300',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  },
  systolicIssue: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-2100',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: 'I-PE-VIT-2300',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  },
  diastolicIssue: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-2500',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: 'I-PE-VIT-2600',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  },
  pulseIssue: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-1600',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: 'I-PE-VIT-1700',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  },
  pulseOxygenIssue: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-2400',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: '',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  },
  respiratoryRateIssue: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-1800',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: 'I-PE-VIT-2000',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  },
  temperatureIssue: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-1400',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: 'I-PE-VIT-1500',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  },
  weight: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-VIT-1000',
          domain: 'DRS',
          triggerValue: 'below'
        },
        {
          id: 'I-PE-VIT-1100',
          domain: 'DRS',
          triggerValue: 'above'
        }
      ]
    }
  }
}
